<script setup lang="ts">
import IconDown from 'assets/icons/arrow-down.svg';
import IconUp from 'assets/icons/arrow-up.svg';

export type TOption = {
  label: string;
};

const { t } = useI18n();

withDefaults(defineProps<{ vertical?: VerticalDirectionT; list: TOption[] }>(),
  {
    vertical: 'down',
  },
);

const selectedOption = defineModel<TOption>('selected');
</script>

<template>
  <HeadlessListbox
    v-slot="{ open }"
    v-model="selectedOption"
    as="div"
    class="relative cursor-pointer flex z-10"
  >
    <HeadlessListboxButton class="w-full">
      <ButtonActive
        :active="open"
        class="w-full"
        type="2"
        :title="t(selectedOption?.label)"
      >
        <template #append>
          <IconDown v-if="!open" />
          <IconUp v-else />
        </template>
      </ButtonActive>
    </HeadlessListboxButton>

    <transition
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <HeadlessListboxOptions
        :class="{
          'top-10': vertical === 'down',
          'bottom-10': vertical === 'up',
        }"
        class="absolute left-0 w-full rounded-medium bg-white shadow-highlight"
      >
        <HeadlessListboxOption
          v-for="(option, i) in list"
          v-slot="{ active }"
          :key="option.label"
          :value="option"
          as="div"
        >
          <div
            :class="[
              i === 0 ? 'rounded-t-medium' : '',
              i === list.length-1 ? 'rounded-b-medium' : '',
              active ? 'bg-gray-300 font-thicker !text-gray-900' : '',
              'w-full !justify-start text-big py-2 px-4 whitespace-nowrap',
            ]"
          >
            {{ t(option.label) }}
          </div>
        </HeadlessListboxOption>
      </HeadlessListboxOptions>
    </transition>
  </HeadlessListbox>
</template>

<style scoped>

</style>
